import { IOmniaShell, omniaResolve, str } from "../omnia"
import { CroppingDependencies, IFieldsService } from "../types"
import { MergedCropViewModel } from "./mergedCropVm"

/// <reference path="../edit/cropping/validate.ts" />

export function validateMerge(cropping: MergedCropViewModel[], shell: IOmniaShell, svc: IFieldsService): ng.IPromise<boolean> {

    const ids = cropping.map(c => c.croppingId)

    return svc.canDeleteCropping(ids).then(deps => {

        return checkLayers(cropping, deps, shell)
            .then(ok => ok ? checkSprayPlans(cropping, deps, shell) : false)
            .then(ok => ok ? confirmNutritionDependencies(cropping, shell) : false)
            .then(ok => ok ? confirmPlanDependencies(cropping, shell) : false)

    })

}

function confirmPlanDependencies(cropping: MergedCropViewModel[], shell: IOmniaShell) {

    if (cropping.some(c => c.cropping.InNutritionPlan || c.cropping.InSeedsPlan)) {

        const msg = `<p>Some of the crops are already part of a plan, and changing the area will change the product totals required within the plans.</p>
                <p>You need to recalculate the plans for the new area to be used.</p>`

        const title = "Recalculate plans"

        return omnia.shell.showOkCancel(shell, msg, title);

    }

    return true

}

function confirmNutritionDependencies(cropping: MergedCropViewModel[], shell: IOmniaShell) {

    if (cropping.some(c => c.cropping.HasNutritionRequirements)) {

        const msg = `<p>Some of the crops you are about to merge already have nutrition requirements.</p>
                <p>You need to recalculate the requirements for these changes to be taken into account. Please note that the plans will also be recalculated as a consequence.</p>`

        const title = "Recalculate crop requirements"

        return omnia.shell.showOkCancel(shell, msg, title)

    }

    return omniaResolve(true)

}


function checkLayers(crops: MergedCropViewModel[], dependencies: CroppingDependencies[], shell: IOmniaShell) {

    return checkDependencies(
        crops,
        dependencies,
        d => d.HasLayers,
        "The selected crops cannot be merged because the following ones have map layers associated",
        shell
    )

}

function checkSprayPlans(crops: MergedCropViewModel[], dependencies: CroppingDependencies[], shell: IOmniaShell) {

    return checkDependencies(
        crops,
        dependencies,
        d => d.HasPublishedSprayPlans,
        "The selected crops cannot be merged because the following ones are part of published spray",
        shell
    )

}

function checkDependencies(
    crops: MergedCropViewModel[],
    dependencies: CroppingDependencies[],
    selector: (cd: CroppingDependencies) => boolean,
    message: string,
    shell: IOmniaShell) {

    const errors = (dependencies || [])
        .filter(selector)
        .map(m => {
            const cropping = crops.find(c => c.croppingId === m.CroppingId)
            return "<li>&ndash;" + cropping.getDescription() + "</li>"
        });

    if (!errors.length) {
        return omniaResolve(true)
    }

    const msg = `<p>${message}</p>${errors.join("")}`

    const title = "These crops cannot be merged"

    return omnia.shell.showWarning(shell,
        msg,
        title,
        str.Ok,
        false
    ).then(() => false)

}

